<template>
    <app-framework>
        <template v-slot:title>
            <tw-divider color="white"
                        width="56"
                        class="mb-3"
            ></tw-divider>
            Languages
        </template>
        <row class="z-10">
            <column align="center" class="text-secondary" cols="full">
                <tw-divider class="mb-5" color="primary" width="56"></tw-divider>
                <div class="poppins-bold tracking-normal xs:text-3xl sm:text-5xl leading-higher mb-10">
                    fitt Languages
                </div>
                <!--                <row no-wrap class="mb-10">-->
                <!--                    <column :align="language.align"-->
                <!--                            :key="index"-->
                <!--                            class="px-3"-->
                <!--                            cols="1/2"-->
                <!--                            v-for="(language, index) in languages"-->
                <!--                    >-->
                <!--                        <card-->
                <!--                            class="flex justify-center items-center text-2xl uppercase poppins-bold text-primary"-->
                <!--                            round style="min-width: 71px; max-width: 71px; min-height: 71px; max-height: 71px;"-->
                <!--                        >-->
                <!--                            {{ language.text }}-->
                <!--                        </card>-->
                <!--                    </column>-->
                <!--                </row>-->
                <div
                    class="xs:text-xl sm:text-2xl tracking-normal xs:leading-snug sm:leading-relaxed text-center">
                    fitt is fully available in <b>English</b> and <b>عربى</b>
                </div>
                <row class="mt-16" style="max-width: 900px;">
                    <column :key="index"
                            lg="1/2" md="1/2" sm="full"
                            v-for="(item, index) in items"
                            xl="1/2" xs="full"
                            class="mb-8"
                    >
                        <row :class="item.justify" align="center" no-wrap>
                            <card
                                class="flex justify-center items-center"
                                round style="min-width: 71px; max-width: 71px; min-height: 71px; max-height: 71px;"
                            >
                                <icon :icon="item.icon" color="primary"></icon>
                            </card>
                            <div class="ml-6 text-md tracking-normal xs:leading-snug sm:leading-relaxed">
                                {{ item.text }}
                            </div>
                        </row>
                    </column>
                </row>
            </column>
        </row>
    </app-framework>
</template>

<script>
    export default {
        name: "Languages",
        components: {
            'app-framework': () => import('@/components/layout/AppFramework.vue'),
            'tw-divider': () => import('@/components/Divider.vue'),
            card: () => import('@/components/Card.vue'),
            icon: () => import('@/components/display/Icon.vue'),
        },
        data: () => ({
            items: [
                {
                    icon: 'chart-line-variant',
                    text: 'The fitt platform and standard journeys are available in English and Arabic.',
                    justify: 'justify-start'
                },
                {
                    icon: 'chart-line-variant',
                    text: 'We are hard at work to make new language options available soon.',
                    justify: 'xs:justify-start sm:justify-start md:justify-end'
                }
            ],
            // languages: [
            //     {text: 'en', align: 'end'},
            //     {text: 'ar', align: 'start'}
            // ]
        }),
    }
</script>

<style scoped>

</style>